import { getChecklistTemplates } from '../../../../api'
import { InputAsyncSelect, InputSelectControl } from '../../../Select'

import { REQUEST_PROFILE_TAB_INTERNAL_TASKS_TEMPLATE_SELECT_API_PARAMS } from './RequestProfileTabInternalTasksTemplateSelect.constants'
import { toChecklistTemplateSelectItems } from './RequestProfileTabInternalTasksTemplateSelect.utils'

function RequestProfileTabInternalTasksTemplateSelect({
  Control = InputSelectControl,
  apiParams = REQUEST_PROFILE_TAB_INTERNAL_TASKS_TEMPLATE_SELECT_API_PARAMS,
  getData = getChecklistTemplates,
  toPreparedItems = toChecklistTemplateSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      apiParams={apiParams}
      getData={getData}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default RequestProfileTabInternalTasksTemplateSelect
